import createEntityBundle from '~/src/Lib/createEntityBundle'
import { IrrigationProgramHistory as schema } from '~/src/Store/Schemas'

export default createEntityBundle({
  name: 'irrigationProgramHistories',
  singularName: 'irrigationProgramHistory',
  apiConfig: { schema, url: 'irrigationProgramHistories' },
})
